import { ActHttpService, HeaderTypes, ContentTypes } from 'app/services/act-http/act-http.service';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RatingDataModel } from 'app/model/rating/rating-data-model';
import { RatingScorePayload } from './payload/rating-score-payload';
import { Response, ResponseContentType, RequestOptions } from '@angular/http';
import { environment } from 'environments/environment';
import { ProductReviewModel } from '../../model/products/product-review.model';

@Injectable()
export class RatingService {

  constructor(
    private actHttpService: ActHttpService,
  ) { }

  getRatingData(token: String): Observable<RatingDataModel> {
    const options = this.actHttpService.getRequestOptions(HeaderTypes.EXCLUDE_TOKEN);
    const url = environment.endpoint.rating.replace(':token', token.toString());

    return this.actHttpService.rawGet(url, options)
      .map((res: Response) => res.json().data);
  }

  submitRatingData(token: String, data: RatingScorePayload, photo): Observable<any> {
    const url = environment.endpoint.rating.replace(':token', token.toString());
    const rating = new FormData();
    rating.append('review', new Blob(
      [JSON.stringify(data)], { type: 'application/json' }
    ));

    if (photo.length > 0) {
      for (let i = 0; i < photo.length; i++) {
        rating.append('photos', photo[i]);
      }
    }

    const responseType = ResponseContentType.Blob;
    return this.actHttpService.rawPost(url, rating, new RequestOptions({ responseType }))
      .map((res: Response) => res);
  }

  uploadImg(data: File) {
    const url = environment.endpoint.resizeUri;
    const request = new FormData();
    request.append('file', data);
    return this.actHttpService.rawPost(url, request).map((res: Response) => { return res; }).toPromise();
  }

  prepareDataForDisplay(reviewRating: ProductReviewModel): ProductReviewModel {
    if (reviewRating.totalScore === '10.0') {
      reviewRating.totalScore = '10';
    }
    reviewRating.ratings = reviewRating.ratings.map(rating => {
      rating.score = rating.score === '10.0' ? '10' : rating.score;
      return rating;
    });
    return reviewRating;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/rating/rating.service.ts